import styled from "styled-components"
import { useState } from "react"

import { CreateNewNotification } from "./CreateNewNotification"
import { AllNotificationsList } from "./AllNotificationsList"
import { Message } from "src/types"

const Root = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: calc(100vh - 200px);
  height: 100vh;
`

/**
 * [ ] Overall layout
 * [ ] Fetch & loop news
 * [ ] Filters?
 * [ ] Individual item UX
 */
export const AdminNotifications = () => {
  // used as shortcut to re-render news
  const [key, setKey] = useState(0)
  const [editMessage, setEditMessage] = useState<Message | null>(null)
  return (
    <Root>
      <AllNotificationsList
        key={key}
        setEditMessage={setEditMessage}
        editMessageId={editMessage?.id}
      />
      <CreateNewNotification
        onSuccess={() => setKey((prev) => prev + 1)}
        cancelEditMessage={() => setEditMessage(null)}
        editMessage={editMessage}
        key={editMessage?.id ?? "new"}
      />
    </Root>
  )
}
